import { inject } from '@angular/core';

import { Logger, WINDOW } from '@frontend/vanilla/core';

import { isNavigationTraversal } from '../../view-transition-navigation.helper';
import { BROWSER_BACK_NAVIGATION_DETECTED_MESSAGE, VIEW_TRANSITION_LOG_TAG as LOG_TAG } from '../../view-transition.constants';
import { BrowserBackDetectionStrategy } from './model/browser-back-detection.strategy.model';

export class NavigationApiBackDetectionStrategy implements BrowserBackDetectionStrategy {
    readonly #logger = inject(Logger);
    readonly #navigation = inject(WINDOW).navigation;

    #previousNavigationHistoryEntry?: NavigationHistoryEntry;

    init(): this {
        this.listenForCurrentEntryChanges();

        return this;
    }

    isBrowserBackNavigation(): boolean {
        if (!isNavigationTraversal()) {
            return false;
        }

        const currentIndex = this.#navigation.currentEntry?.index;
        const previousIndex = this.#previousNavigationHistoryEntry?.index;

        if (currentIndex === undefined || previousIndex === undefined) {
            return false;
        }

        const isBrowserBackNavigation = currentIndex < previousIndex;

        if (isBrowserBackNavigation) {
            this.#logger.info(`${LOG_TAG} ${BROWSER_BACK_NAVIGATION_DETECTED_MESSAGE}`);
        }

        return isBrowserBackNavigation;
    }

    private listenForCurrentEntryChanges(): void {
        this.#navigation.oncurrententrychange = (event: NavigationCurrentEntryChangeEvent) => {
            if (event.navigationType === 'push' || event.navigationType === 'traverse') {
                this.#previousNavigationHistoryEntry = event.from;
            }
        };
    }
}
